import Vue from 'vue'
import commonMutations from '@/store/ui/common/mutations'
import { get, isNil } from 'lodash'

const mutations = {
    ...commonMutations,
    setDisplayModal(state, { modal, isDisplayed }) {
        Vue.set(state.displayModal, modal, isDisplayed)
    },
    setIsEditing(state, { isEditing }) {
        Vue.set(state, 'isEditing', isEditing)
    },

    setSelectedEvent(state, { eventType, event }) {
        Vue.set(state.selectedEvents, eventType, event)
    },

    setFormulaVolumes(state, { volumes }) {
        Vue.set(state, 'formulaVolumes', volumes)
    },

    setFirstPartySelection(state, { items }) {
        Vue.set(state, 'firstPartySelection', items)
    },

    setFirstPartySelectAll(state, { mediaType, isSelecting }) {
        Vue.set(state.firstPartySelectAll, mediaType, isSelecting)
    },

    resetSelectedFirstPartyOnClose(state, { firstPartySelection, firstPartySelectAll }) {
        Vue.set(state, 'firstPartySelection', firstPartySelection)
        Vue.set(state, 'firstPartySelectAll', firstPartySelectAll)
    },

    resetSelectedEventsOnClose(state, { eventType, event }) {
        if (!isNil(eventType)) {
            if (isNil(event)) {
                Vue.set(state.selectedEvents, eventType, null)
                if (eventType === 'negative') {
                    Vue.set(state.selectedEvents, 'database', true)
                }
            } else {
                if (eventType === 'positive') Vue.set(state.selectedEvents, eventType, event)
                if (eventType === 'negative') {
                    if (!isNil(get(event, 'database', null))) {
                        Vue.set(state.selectedEvents, 'database', true)
                    } else {
                        Vue.set(state.selectedEvents, eventType, event)
                        Vue.set(state.selectedEvents, 'database', false)
                    }
                }
            }
        }
    },

    setEventType(state, { eventType }) {
        Vue.set(state, 'eventType', eventType)
    },

    setCriteriaType(state, { eventType, criteriaType, history }) {
        Vue.set(state.criteriaTypes[eventType], history, criteriaType)
    },

    resetCriteriaTypes(state) {
        Vue.set(state.criteriaTypes, 'positive', { current: null, previous: null })
        Vue.set(state.criteriaTypes, 'negative', { current: null, previous: null })
    },

    resetEventsStoreOnCcloneFormClose(state) {
        Vue.set(state.criteriaTypes, 'positive', { current: null, previous: null })
        Vue.set(state.criteriaTypes, 'negative', { current: null, previous: null })
        Vue.set(state.selectedEvents, 'positive', null)
        Vue.set(state.selectedEvents, 'negative', null)
        Vue.set(state.selectedEvents, 'database', true)
        Vue.set(state, 'firstPartySelection', [])
        Vue.set(state, 'firstPartySelectAll', {})
    },

    setSelectedCclone(state, { id }) {
        Vue.set(state, 'selectedCcloneId', id)
    }
}

export default mutations
